var optionsMd = {
  arrows: false,
  centerMode: true,
  dots: true,
  slidesToShow: 3
}

var optionsSm = {
  arrows: false,
  centerMode: true,
  dots: true,
  slidesToShow: 1
}

function initD3(options) {
  if (
    !jQuery('.region-content .third-width-wrapper').hasClass(
      'slick-initialized'
    )
  ) {
    jQuery('.region-content .third-width-wrapper').slick(options)
  }
}

function unD3() {
  if (
    jQuery('.region-content .third-width-wrapper').hasClass('slick-initialized')
  ) {
    jQuery('.region-content .third-width-wrapper').slick('unslick')
  }
}

function initD4(options) {
  if (
    !jQuery('.region-content .quarter-width-wrapper').hasClass(
      'slick-initialized'
    )
  ) {
    jQuery('.region-content .quarter-width-wrapper').slick(options)
  }
}

function unD4() {
  if (
    jQuery('.region-content .quarter-width-wrapper').hasClass(
      'slick-initialized'
    )
  ) {
    jQuery('.region-content .quarter-width-wrapper').slick('unslick')
  }
}

function handleLg() {
  unD3()
  unD4()
}

function handleMd() {
  unD3()
  unD4()
  jQuery('.region-content .third-width-wrapper').prepend(function() {
    return jQuery(this).next().find('.third-width')
  })
  initD4(optionsMd)
}

function handleSm() {
  if (!jQuery('body').hasClass('page-node-type-home-page')) {
    if (jQuery('.region-content .quarter-width-wrapper').length > 0) {
      unD4()
      jQuery('.region-content .quarter-width-wrapper').prepend(function() {
        return jQuery(this).prev().find('.third-width')
      })
      initD4(optionsSm)
      // For image card set with only third-width children
      // that couldn't get merged with d4 elements.
      if (
        jQuery('.region-content .third-width-wrapper .third-width').length > 2
      ) {
        initD3(optionsSm)
      }
    } else if (
      jQuery('.region-content .quarter-width-wrapper').length === 0 &&
      jQuery('.region-content .third-width-wrapper .third-width').length > 2
    ) {
      initD3(optionsSm)
    }
  }
}

export default function handleRender() {
  if (jQuery(window).width() > 768) {
    handleLg()
  } else if (jQuery(window).width() > 640 && jQuery(window).width() <= 768) {
    handleMd()
  } else if (jQuery(window).width() <= 640) {
    handleSm()
  }
}
